import actions from './actions';

const set = (ModalClass, modalProps) => (dispatch, getState) => {
  dispatch(actions.set(ModalClass, modalProps))
};

const unset = () => (dispatch, getState) => {
  dispatch(actions.unset())};


export default {
  set,
  unset
};



// WEBPACK FOOTER //
// ./src/redux/modal/operations.js